import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { translate } from 'translations/translator';
import LessonAssignmentTranslationVariant from 'translations/variants/lessonAssignment';

type Props = {
  title: string;
  activities: Array<{ title: string; type: { type: string; title: string } }>;
};

const getTranslation = (key: LessonAssignmentTranslationVariant, options?) =>
  translate('lessonAssignment', key, options);
export const StepThreeLessonCard: React.FC<Props> = ({ title, activities }) => {
  const classes = useStyles()();
  return activities.length > 0 ? (
    <Paper className={classes.Paper}>
      <Box className={classes.assignmentCardContainer}>
        <Typography variant="h5" style={{ marginBottom: '5px', fontWeight: 400 }}>
          {title} {`(${activities.length})`}
        </Typography>
        {activities.map((x, idx) => (
          <Box key={`activities-container-${idx}`} className={classes.card}>
            <Box key={`activities-title-${idx}`} style={{ maxWidth: '500px' }}>
              <Typography variant="body1">{x.title}</Typography>
              <Typography
                variant="caption"
                style={{ color: '#6A6A6A', fontWeight: 400, marginLeft: '5px' }}
              >
                {`- ${getTranslation(LessonAssignmentTranslationVariant.activityType)}: ${
                  x?.type?.title
                }`}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  ) : null;
};

const useStyles = () =>
  makeStyles(() => ({
    card: {
      display: 'flex',
      padding: '5px'
    },
    assignmentCardContainer: {
      padding: '24px'
    },
    Paper: {
      margin: '15px 0',
      boxShadow:
        '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12) !important'
    }
  }));
